import useLocalDispatch from "hooks/useLocalDispatch";
import { Grid, Box } from "@mui/material";
import { useMount } from "react-use";
import useUrl from "hooks/useUrl";
import { fetchEntityErrors } from "thunk";
import useSimpleMuiTableBuilder from "hooks/useSimpleMuiTableBuilder";
import { getTableConfigs, StateIds } from "./tableConfigs";
import { filterIds } from "@constants";
import orderBy from "lodash/orderBy";
import { EntityError } from "./types";
import { FetchEntityErrorsParams } from "IntegrationModule/types";
import useAppNavigation from "hooks/useAppNavigation";

type StateData = EntityError[];

type FormattedData = EntityError[];

const EntityErrorContainer = () => {
  const { dispatchLocal, selectLocalData } = useLocalDispatch();
  const { queryTargetServiceId, queryEntityId } = useUrl();
  const { navigateToTeamsTable } = useAppNavigation();

  useMount(() => {
    // Navigate to reports page if queryEntityId is not valid
    if (Number.isNaN(queryEntityId) || queryEntityId === 0) {
      navigateToTeamsTable();
    } else {
      dispatchLocal<StateData, FetchEntityErrorsParams>(fetchEntityErrors, {
        params: {
          targetServiceId: queryTargetServiceId,
          entityId: queryEntityId,
        },
        stateId: StateIds.EntityError,
      });
    }
  });

  const { data, isRequesting, filter } = selectLocalData<
    FormattedData,
    StateData
  >({
    stateId: StateIds.EntityError,
    filterId: filterIds.entityErrorTable,
    formatData: ({ stateData, filter }) => {
      return orderBy(stateData, filter.orderBy, filter.orderDirection);
    },
  });

  const { TableComponent: EntityErrorsTable } = useSimpleMuiTableBuilder({
    isLoading: isRequesting,
    filter,
    flatList: data,
    ...getTableConfigs({ variant: undefined }),
    // onRowClick: (
    //   e: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    //   { id }: FormattedRowData
    // ) => {
    //   if (!e.defaultPrevented) {
    //     const nav = navigateToTeamProfile(id as number);
    //     nav();
    //   }
    // },
    tableMaxHeight: "1000px",
  });

  return (
    <Grid>
      <EntityErrorsTable />
    </Grid>
  );
};

export default EntityErrorContainer;
